module.exports = __webpack_public_path__ + "img/Bridgerton poster.df439c83.png";